module.exports = __webpack_public_path__ + "img/_chat_bubble_small_primary.fe12170e.svg";